module.exports = __webpack_public_path__ + "img/rayures.397717d5.png";